module.exports = __webpack_public_path__ + "static/media/LinusFlowersBarFrancis.e7eea9d6.jpg";